import { connect } from 'react-redux';
import EventEditor from '../components/EventEditor';
import { lifecycle, compose, withState, withHandlers } from 'recompose';
import { currentGroup } from 'utils/credentials';
import { store } from 'store/createStore';
import { open } from 'store/modules/modal';
import moment from 'moment';
import API from '../../../../../utils/api';

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => ({
  errorModal(message) {
    dispatch(
      open({
        modalType: 'error',
        modalProps: {
          message: message,
        },
      })
    );
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('channelId', 'setChannelId', null),
  withState('channelName', 'setChannelName', ''),
  withState('eventId', 'setEventId', null),
  withState('group', 'setGroup', null),
  withState('leaguesList', 'setLeaguesList', []),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('gamesList', 'setGamesList', []),
  withState('datesWithGames', 'setDatesWithGames', []),
  withState('eventForm', 'setEventForm'),
  withState('hostList', 'setHostList', []),
  withState('imageList', 'setImageList', []),
  withState('hostPageSize', 'setHostPageSize', 5),
  withState('templatesList', 'setTemplatesList', []),
  withState('templatesPageSize', 'setTemplatesPageSize', 5),
  withState('backgroundList', 'setBackgroundList', []),
  withState('myVersusDemo', 'setMyVersusDemo', false),
  withHandlers({
    getDaysWithGames: props => games => {
      let allDates = [];
      for (const game of games) {
        allDates.push(moment(game.scheduled).format('DD MMM YYYY'));
      }

      let uniqueDates = allDates.filter((v, i, a) => a.indexOf(v) === i);

      let newDates = [];
      for (let d of uniqueDates) {
        newDates.push(moment(d).toDate());
      }

      props.setDatesWithGames(newDates);
    },
  }),
  withHandlers({
    UpdateListLeaguesAndGame: props => (leagueSelected, eventId) => {
      API.getLeagues({
        ignoreDependencies: true,
        query: JSON.stringify({ active: true }),
      }).then(({ data }) => {
        props.setLeaguesList(data ? data.docs || [] : []);
      });

      const query = {
        leagueId: leagueSelected ? leagueSelected : null,
        eventId: eventId ? eventId : null,
        shift: 400,
        eventEditor: true,
      };
      API.getSchedule(query).then(data => {
        const gameList = data.gameList ? data.gameList : [];
        props.getDaysWithGames(gameList);
        props.setGamesList(gameList);
      });
    },
    UpdateListGames: props => (leagueSelected, eventId, selectedDate) => {
      const query = {
        leagueId: leagueSelected ? leagueSelected : null,
        eventId: eventId ? eventId : null,
        singleDay: selectedDate ? new Date(selectedDate) : null,
        eventEditor: true,
      };
      API.getSchedule(query).then(data => {
        const gameList = data.gameList ? data.gameList : [];
        props.setGamesList(gameList);
      });
    },
    fetchTemplates: props => () => {
      API.getTemplates({
        select: 'name createdAt updatedAt type icon',
      }).then(({ data }) => {
        if (data && data.docs) {
          props.setTemplatesList(data.docs);
        }
      });
    },
    fetchDefaultBg: props => () => {
      API.getFiles({
        select: 'container blob fileName',
        query: `{"metadata.tag": "webapp_background_default" }`,
      }).then(data => {
        if (data && data.docs) {
          props.setBackgroundList(data.docs);
        }
      });
    },
    fetchHosts: props => () => {
      API.getUsers().then(({ data }) => {
        if (data && data.docs) {
          props.setHostList(data.docs);
        }
      });
    },
    fetchImageList: props => () => {
      API.getImageLibraryList().then(({ data }) => {
        props.setImageList(data);
      });
    },
    createEvent: props => formData => {
      try {
        API.createChannelEvent({ ...formData, channelId: props.channelId }).then(
          ({ error }) => {
            if (error) {
              props.setErrorMessage(error);
            } else {
              props.history.push({
                pathname: '/dashboard/channel/admin/events',
                state: {
                  channelId: props.channelId,
                  channelName: props.channelName,
                },
              });
            }
          }
        );
      } catch (error) {
        console.log('Error: ', error);
      }
    },
    updateEvent: props => data => {
      API.updateChannelEvent(props.eventId, data).then(() =>
        props.history.push({
          pathname: '/dashboard/channel/admin/events',
          state: {
            channelId: props.channelId,
            channelName: props.channelName,
          },
        })
      );
    },
  }),
  withHandlers({
    fillEventForm: props => (eventId, form) => {
      props.setEventId(eventId);

      props.UpdateListLeaguesAndGame(
        form.leagueSelected ? form.leagueSelected : null,
        eventId
      );

      props.setEventForm(form);
    },
    updateErrorMessage: props => message => {
      props.setErrorMessage(message);
    },
  }),
  lifecycle({
    componentDidMount() {
      try {
        if (this.props.location.state.channelId) {
          const { channelId, channelName, myVersusDemo } = this.props.location.state;

          if (!this.props.location.state.event) {
            this.props.UpdateListLeaguesAndGame(null);
          }

          this.props.setMyVersusDemo(myVersusDemo);
          this.props.setChannelId(channelId);
          this.props.setChannelName(channelName);
          this.props.setGroup(store.getState().auth.currentGroup._id);

          this.props.fetchTemplates();
          this.props.fetchDefaultBg();
          this.props.fetchHosts();
          this.props.fetchImageList();

          window.scrollTo(0, 0);
        } else {
          this.props.history.push('/dashboard/channel/admin');
        }
      } catch (error) {
        this.props.history.push('/dashboard/channel/admin');
      }
    },
    componentDidUpdate() {
      if (this.props.group !== store.getState().auth.currentGroup._id) {
        this.props.history.push('/dashboard/channel/admin');
      }
    },
  })
);

export default enhance(EventEditor);
